import { NavLink } from "react-router-dom";
import Navbar from "../components/Navbar/NavBar";
import "./NotFound.css";

const NotFound = () => {
  return (
    <>
      <Navbar />
      <div className="notfound">
        <img src="/404 error.svg" alt="not found" />
        <h2>Oops!</h2>
        <h3>Something Went Wrong</h3>
        <NavLink to="/dashboard">Back to Home</NavLink>
      </div>
    </>
  );
};

export default NotFound;
